import { postRequest } from "../apis/axiosAction";
import { DEFAULT_PAGE_SIZE } from "../constant/applicationConstant";
/**
 * 案件一覧のプロジェクトデータ
 */
export const apiParamDefault = {
    tenpoNo: "",
    tenpoName: "",
    zoCode: "",
    zoName: "",
    doCode: "",
    doName: "",
    ofcName: "",
    projectNo: "",
    businessType: "",
    programName: "",
    projectStatus: "",
    status: "",
    progressStatus: "",
    startDateFrom: "",
    startDateTo: "",
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    columnPattern: "minimal" // 列最小化パターン（14カラムのみ取得）
};
/**
 * null値を空文字列に変換するヘルパー関数
 */
export function normalizeNullValues(data) {
    const normalized = {};
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            normalized[key] = data[key] === null || data[key] === undefined ? '' : data[key];
        }
    }
    // equipmentProjectCompleteDateをendDateにマッピング
    if (data.equipmentProjectCompleteDate !== null && data.equipmentProjectCompleteDate !== undefined) {
        normalized.endDate = data.equipmentProjectCompleteDate;
    }
    return normalized;
}
/**
 * APIからプロジェクトデータを取得する（ページング対応）
 * @param apiParam 検索条件とページング情報
 * @returns プロジェクト検索レスポンス（データとページング情報）
 */
export async function loadProjectDataFromApi(apiParam = apiParamDefault, isLoading = true) {
    try {
        const domain = process.env.APP_API_URL;
        const url = `${domain}j21spb32/project-search-list`;
        const response = await postRequest(url, apiParam, false, isLoading);
        // API v3.0の新しいレスポンス形式に対応
        const apiResponse = response.data;
        if (apiResponse.success && apiResponse.message) {
            // null値を空文字列に変換
            const normalizedProjects = apiResponse.message.projects.map(item => normalizeNullValues(item));
            return {
                projects: normalizedProjects,
                pagination: apiResponse.message.pagination
            };
        }
        else {
            console.error('API Error:', apiResponse.errorMessage);
            return {
                projects: [],
                pagination: {
                    page: 1,
                    pageSize: DEFAULT_PAGE_SIZE,
                    totalRecords: 0,
                    totalPages: 0,
                    hasNext: false,
                    hasPrevious: false
                }
            };
        }
    }
    catch (error) {
        console.error('Error loading project data from API:', error);
        // エラー時は空のレスポンスを返す
        return {
            projects: [],
            pagination: {
                page: 1,
                pageSize: DEFAULT_PAGE_SIZE,
                totalRecords: 0,
                totalPages: 0,
                hasNext: false,
                hasPrevious: false
            }
        };
    }
}
/**
 * APIからプロジェクトデータを取得する（従来の互換性関数）
 * @param apiParam 検索条件
 * @returns プロジェクトデータの配列のみ
 * @deprecated ページング情報が必要な場合は loadProjectDataFromApi を使用してください
 */
export async function loadProjectDataFromApiLegacy(apiParam = apiParamDefault) {
    const response = await loadProjectDataFromApi(apiParam);
    return response.projects;
}
